// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TAddDependentRequestPayload,
  TAddDependentResponsePayload,
  TListDependentsRequestPayload,
  TListDependentsResponsePayload,
  TRemoveDependentRequestPayload,
  TRemoveDependentResponsePayload,
} from './dependents.types.ts';

export const createDependentsApi = (transport: TApiTransport) => ({
  /** Adds a dependent for the user */
  addDependent: (
    payload: TAddDependentRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TAddDependentRequestPayload, TAddDependentResponsePayload>(
      '/add_dependent',
      payload,
      options,
    ),

  /** Lists the user's dependents */
  listDependents: (
    payload: TListDependentsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TListDependentsRequestPayload,
      TListDependentsResponsePayload
    >('/list_dependents', payload, options),

  /** Removes a dependent from the user */
  removeDependent: (
    payload: TRemoveDependentRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TRemoveDependentRequestPayload,
      TRemoveDependentResponsePayload
    >('/remove_dependent', payload, options),
});
